import styled from '@emotion/styled';
import { Button } from '@innovationdepartment/proxima-ui';
import ButtonGroup from 'ui/ButtonGroup';
import SectionLayout from 'ui/SectionLayout';
import BrandProductsCards from './BrandProducts.Cards';
import BrandProductsTable from './BrandProducts.Table';
import BrandProductsToolbar from './BrandProducts.Toolbar';
import type { BrandProductsViewProps } from './types';

const BrandProductsContainer = styled.div`
  height: calc(100% - 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
`;

const BrandProductsLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100% - 64px);
`;

const BrandProductsView = (props: BrandProductsViewProps) => {
  const { view, onNext, onPrevious } = props;

  return (
    <SectionLayout title="Brand Products">
      <BrandProductsLayoutContainer>
        <BrandProductsToolbar {...props} />
        <BrandProductsContainer>
          {view === 'table' && <BrandProductsTable {...props} />}
          {view === 'cards' && <BrandProductsCards {...props} />}
        </BrandProductsContainer>
      </BrandProductsLayoutContainer>
      <ButtonGroup>
        {!!onPrevious && <Button label="Previous" onClick={onPrevious} />}
        {!!onNext && <Button label="Next" onClick={onNext} />}
      </ButtonGroup>
    </SectionLayout>
  );
};

export default BrandProductsView;
